import React from 'react';
import { useProjectSyncingService } from 'nekst-api';
import { AfterSubmitFunc, Button, ButtonSize, usePopupManager } from 'ui-builder';
import { Popup, PopupText } from 'features/nekst-widgets';
import { useFubConnectionContext } from '../../../Integrations';

export default function CreateExternalProjectForm(
  props: {
    projectId: number,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const projectSyncingService = useProjectSyncingService();

  const fubContext = useFubConnectionContext();

  const profile = fubContext?.profiles?.[0];

  const popupManager = usePopupManager();

  if (profile) {
    return (
      <Popup
        title="Create a Deal In Follow Up Boss"
        content={(
          <PopupText>
            Upon clicking the button below, a new Deal will be created in Follow Up Boss and linked
            to this transaction. Future changes to this Transaction within Nekst will also sync in
            FUB.
          </PopupText>
        )}
        buttons={(
          <Button
            text="Create"
            size={ButtonSize.BIG}
            onClick={async () => {
              await projectSyncingService.createNewExternalProject(
                props.projectId,
                {
                  connectionProfileId: profile.id
                }
              );
              popupManager.closePopup();
            }}
          />
        )}
      />
    );
  } else {
    return null;
  }
}
